import React from "react";
import { ValidateCoderLink } from "./validate-coder-link";
import moment from "moment";

import { getTaskLink } from "../lib/constants";
import { MOMENT_LONG_DATE_FORMAT } from "../../../shared/constants";

export const TaskDetail = ({ task, includeDescription }) => {
    const { taskUpdatedOn, description } = task;
    const taskLink = getTaskLink(task);
    const formattedDate = moment.utc(task.taskUpdatedOn).format(MOMENT_LONG_DATE_FORMAT);
    const label = `${formattedDate} by ${task.taskUpdatedBy}`;

    return (
        <div className="task-detail">
            <div className="flex align-center m-b-4">
                {taskLink && (
                    <ValidateCoderLink
                        taskType={task.taskType}
                        taskKey={task.key}
                        taskLink={taskLink}
                    />
                )}
                {includeDescription && <h4 className="m-t-4">{description.split("-").shift()}</h4>}
            </div>
            <p>
                <b>Updated on:</b>
                <br />
                {taskUpdatedOn ? <span>{label}</span> : <i>Data not available</i>}
            </p>
        </div>
    );
};
